<template>
  <div class="flex flex-col rounded-3xl bg-white shadow-md" :style="{width: videoWidth + 'px'}">
    <div>
      <iframe
        :width="videoWidth"
        :height="videoHeight"
        loading="lazy"
        :src="'https://www.youtube.com/embed/' + videoId"
        frameborder="0"
        allowfullscreen
        style="overflow: hidden"
        :style="roundness"
      ></iframe>
    </div>
    <div class="p-4 md:block hidden">
      <h3 class="text-lg font-bold text-[#F6A02C]">{{title}}</h3>
      <p class="text-sm text-gray-500">{{author}}</p>
    </div>
  </div>
</template>

<script>
import {useWindowSize} from "@vueuse/core";
import {computed} from "vue";

export default {
  props: {
    title: String,
    author: String,
    videoId: String,
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.resize);
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resize);
  },
  methods: {
    resize() {
      this.videoWidth = this.getVideoWidth(window.screen.width);
      this.videoHeight = this.getVideoHeight(window.screen.width);
    },
    getVideoWidth(width) {
      if(width <= 800) {
        return width-40;
      } else if (width < 1105) {
        return (width/2)-40;
      }

      return 480;
    },
    getVideoHeight(width) {
      if(width <= 800) {
        return ((width-40)/16)*9;
      } else if (width < 1105) {
        return ((width/2)-40)*0.5625;
      }

      return 270;
    }
  },
  data() {
    return {
      videoWidth:  this.getVideoWidth(window.screen.width),
      videoHeight:  this.getVideoHeight(window.screen.width)
    }
  },
  setup() {
    const { width } = useWindowSize();

    const roundness = computed(() => {
      if(width.value < 1024) {
        return "border-radius: 1.5rem 1.5rem 1.5rem 1.5rem";
      } else {
        return "border-radius: 1.5rem 1.5rem 0 0";
      }
    })

    return {
      roundness
    }


  }
}
</script>

<style scoped>

</style>
